import { useEffect, useMemo, useState } from 'react'

import {
  buildDefaultChipOrder,
  reconcileChipOrder,
  visibleChipOrder,
} from '@/lib/list-filters/unified-chip-order'

export function useUnifiedChipOrder(
  showTextSearchChip: boolean,
  appliedFilterKeys: string[],
  orderedKeys: string[],
) {
  const appliedKeysKey = appliedFilterKeys.join('\0')

  const [chipOrder, setChipOrder] = useState<string[]>(() =>
    buildDefaultChipOrder(showTextSearchChip, appliedFilterKeys, orderedKeys),
  )

  useEffect(() => {
    const keys = appliedKeysKey.length > 0 ? appliedKeysKey.split('\0') : []
    setChipOrder((prev) => reconcileChipOrder(prev, showTextSearchChip, keys))
  }, [showTextSearchChip, appliedKeysKey])

  const orderedVisibleKeys = useMemo(
    () => visibleChipOrder(chipOrder, showTextSearchChip, appliedFilterKeys),
    [chipOrder, showTextSearchChip, appliedFilterKeys],
  )

  return { chipOrder, setChipOrder, orderedVisibleKeys }
}
